import React from "react";
import Navbar from '../components/Navbar';
import Bookcase from '../components/Bookcase';


export default function Dashboard() {
  
  return (
    <div>
      <Navbar />
      <div className="background">
        <div className="home-container" id="homeContainer">
          <Bookcase /> 
        </div>
      </div>
    </div>
  );
}
